import { useSelector } from 'react-redux';

import { Store } from '@/shared/store';

export const useModal = () => {
    return {
        ...useSelector((state: Store) => ({
            modalName: state.modals.activeModal,
            modalTitle: state.modals.modalTitle,
            modalProps: state.modals.modalProps,
            onClose: state.modals.onClose,
            previousModal: state.modals.previousModal,
        })),
    };
};
